class Validator
{
    /**
     * Create a new validator instance.
     */
    Validator()
    {
        this.clearErrors();
    }

    /**
     * Empty all errors.
     * 
     * @return {void}
     */
    clearErrors()
    {
        this.errors = {};
    }

    /**
     * Add an error.
     * 
     * @param {String} field
     * @param {String} error
     */
    addError(field, error)
    {
        if(!this.errors[field])
            this.errors[field] = [];
        this.errors[field].push(error);
    }

    /**
     * Check if the validator has errors.
     * 
     * @return {boolean}
     */
    hasErrors() {
        return Object.keys(this.errors).length > 0 ? true : false;
    }

    /**
     * Check if a field has a certain error.
     * 
     * @param {String} field
     * 
     * @return boolean
     */
    has(field)
    {
        return this.errors && this.errors[field] && this.errors[field].length > 0 ? true : false;
    }

    /**
     * Get the errors of the given field.
     * 
     * @param {String} field
     * 
     * @return {mixed}
     */
    get(field)
    {
        return this.has(field) ? this.errors[field] : null;
    }

    /**
     * Get all the errors.
     * 
     * @return {mixed}
     */
    all()
    {
        return this.errors;
    }

    /**
     * Get all the errors as list of strings.
     * 
     * @return {Array}
     */
    list()
    {
        if(!this.hasErrors())
            return [];

        return [].concat.apply([], Object.values(this.errors));
    }

    /**
     * Validate the qnumber.
     * 
     * @param {Array} fields
     * @param {Array} rules
     * 
     * @return {mixed}
     */
    validate(fields, rules)
    {
        this.clearErrors();
        
        for(let field in rules) {
            let ruleGroup = rules[field].split("|");
            for(let ruleKey in ruleGroup) {
                let rule = ruleGroup[ruleKey].split(":");
                // rule[0] => function name
                // rule[1] => parameters
                let error = this[rule[0]](field, fields[field], rule[1]);
                if(error)
                    this.addError(field, error);
            }
        }

        return this;
    }

    /* ========== BELOW ARE FUNCTIONS THAT VALIDATE THE RULES ========== */

    /**
     * Check if a string has the specified minimum number of characters.
     * 
     * @param {String} field
     * @param {String} value 
     * @param {Int} numberOfCharacters 
     * 
     * @return {null|string}
     */
    min(field, value, numberOfCharacters) {
        return value.length >= numberOfCharacters 
            ? null
            : `${field} must be at least ${numberOfCharacters} character(s).`;
    }

    /**
     * Check if a string does not exceed the specified number of characters.
     * 
     * @param {String} field 
     * @param {String} value 
     * @param {Int} numberOfCharacters 
     * 
     * @return {null|string}
     */
    max(field, value, numberOfCharacters) {
        return value.length <= numberOfCharacters 
            ? null 
            : `${field} must not exceed ${numberOfCharacters} character(s).` ;
    }

    /**
     * Make sure a string is required.
     * 
     * @param {String} field
     * @param {String} value
     * 
     * @return {null|String}
     */
    required(field, value)
    {
        return value !== null && value !== undefined && value.length > 0 
            ? null 
            : `${field} is required.`;
    }

}

export default Validator;